import { useEffect, useState } from "react";
import { Loader2, ShieldAlert } from "lucide-react";
import { api } from "../lib/api";

export function DeployGuardBanner() {
  const [data, setData] = useState(null);
  useEffect(() => {
    const load = () => api.get("/vouchers/generate-active").then((r) => setData(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, []);
  if (!data?.count) return null;
  return (
    <div className="rounded-xl border border-amber-500/50 bg-amber-500/10 p-3 sm:p-4 flex gap-3 items-start" data-testid="deploy-guard-banner">
      <ShieldAlert className="w-5 h-5 text-amber-400 shrink-0 mt-0.5 animate-pulse" />
      <div className="min-w-0 flex-1">
        <div className="font-semibold text-amber-300 text-sm">JANGAN deploy / restart dulu — {data.count} proses cetak voucher sedang berjalan</div>
        <p className="text-xs text-muted-foreground mt-0.5">Tunggu sampai banner ini hilang (biasanya kurang dari 1 menit) agar agen tidak terganggu. Bila terpaksa, kode yang sudah jadi tetap aman dan proses dilanjutkan otomatis setelah server hidup.</p>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {data.jobs.map((j) => (
            <span key={j.job_id} className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md bg-background/60 border border-amber-500/30 text-[11px] font-mono" data-testid={`deploy-guard-job-${j.job_id}`}>
              {j.alive ? <Loader2 className="w-3 h-3 animate-spin text-amber-400" /> : <span className="w-2 h-2 rounded-full bg-rose-500" title="tidak ada detak — akan dilanjutkan otomatis" />}
              {j.router_name || "?"} · {j.profile} · {j.done}/{j.total} · {j.email}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
